import React from "react";
import {
	Loader,
	NoDataIndication,
} from "../views/ticketModule/variables/ListingVariables";

export const TableLoader = ({ tableLoader }) => {
	return tableLoader ? <Loader /> : <NoDataIndication />;
};
